import { render, staticRenderFns } from "./studentRouteTable.vue?vue&type=template&id=96812d46"
import script from "./studentRouteTable.vue?vue&type=script&lang=js"
export * from "./studentRouteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports